import React from 'react';
import classNames from 'classnames';

export default function CardDescription({
    text,
    className = 'CommonRatioCard__description',
}) {
    return <div className={classNames(className)}>{text}</div>;
}
